module.exports = __webpack_public_path__ + "img/photo.b472066b.svg";